import React, { useContext } from "react";
import { Drawer } from "antd";
import { StorefrontContext } from "../../context/storefrontContext";

export const DrawerHocStorefront = (props) => {
  const { closeCart, isCartOpen } = useContext(StorefrontContext);

  if (isCartOpen) {
    return (
      <Drawer
        title={props.title}
        footer={props.footer}
        placement="right"
        closable
        width="500"
        onClose={closeCart}
        visible={isCartOpen}
        getContainer={false}
      >
        {props.children}
      </Drawer>
    );
  }
  return <noscript />;
};

export default DrawerHocStorefront;
